import MarketSettingsUsersSubscriptionAccessController from 'lumen/controllers/market/settings/users/subscription-access';

export default class DestinationSettingsUsersSubscriptionAccessController extends MarketSettingsUsersSubscriptionAccessController {
  usersRouteName = 'destination.settings.users';
}
